import { render, staticRenderFns } from "./config3Certificado.vue?vue&type=template&id=7516cf8e&scoped=true"
import script from "./config3Certificado.vue?vue&type=script&lang=js"
export * from "./config3Certificado.vue?vue&type=script&lang=js"
import style0 from "./config3Certificado.vue?vue&type=style&index=0&id=7516cf8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516cf8e",
  null
  
)

export default component.exports